import { AbstractControl, ValidationErrors } from '@angular/forms';

export function vatNumberValidator(
  control: AbstractControl,
): ValidationErrors | null {
  const value = (control.value || '').trim();
  return !value || /^[0-9]{11}$/.test(value) ? null : { vatNumber: true };
}
